import React from "react";
import { Tag } from "antd";
import { useTranslations } from "translations/useTranslations";

import { FacetSetItemUI } from "modules/FacetsModule/components/FacetSetItemUI";
import { useBrandName } from "modules/MatchingModule/MatchingGroupsModule/components/MatchedProductDrawer/hooks/useBrandName";
import { useMatchedProductFilter } from "modules/MatchingModule/MatchingGroupsModule/components/MatchedProductDrawer/hooks/useMatchedProductFilter";

export const MatchedProductChip = React.memo(() => {
  const translations = useTranslations();
  const { brandId, matchedItemIds, clear } = useMatchedProductFilter();
  const brandName = useBrandName(brandId);

  if (!brandId) return null;

  // matched_item holds only the brand id when none of its products is matched in the view
  const productCount = matchedItemIds.filter((id) => id !== brandId).length;
  const productsLabel =
    productCount === 1
      ? translations["matching.matched_product.chip.product"]
      : translations["matching.matched_product.chip.products"].replace("{{count}}", String(productCount));

  return (
    <Tag closable onClose={clear} className="whitespace-normal" style={{ margin: 0 }}>
      <FacetSetItemUI
        title={translations["matching.matched_product.chip.title"]}
        items={productCount ? [brandName || brandId, productsLabel] : [brandName || brandId]}
        separator=" · "
      />
    </Tag>
  );
});
